const RESERVED_USERNAMES = new Set(['admin', 'root', 'system', 'guest', 'spectator']);

export type UsernameValidationResult =
  | { ok: true; normalized: string }
  | { ok: false; reason: 'length' | 'reserved' };

export function normalizeUsername(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/[\s_.]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function isReservedUsername(normalized: string): boolean {
  return RESERVED_USERNAMES.has(normalizeUsername(normalized));
}

export function validateUsername(input: string): UsernameValidationResult {
  const normalized = normalizeUsername(input);

  if (normalized.length < 3 || normalized.length > 32) {
    return { ok: false, reason: 'length' };
  }

  if (isReservedUsername(normalized)) {
    return { ok: false, reason: 'reserved' };
  }

  return { ok: true, normalized };
}

export function formatUsernameForDisplay(normalized: string | null | undefined): string {
  return normalized ? `@${normalized}` : 'Not set';
}
